import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { catchError, concatMap, map, of, switchMap, tap } from 'rxjs';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { OrderDetailsActions } from '../actions/index';
import { OrderDetailsEffectsService } from './order-details-effect.service';
import { SharedActions } from '../../../../SGRE-shared/store/shared-store/actions';
import { CustomCart } from '../../../cart/models/custom-cart.model';
import { CartsByLegalEntity } from '../../../../SGRE-shared/models/cartsByLegalEntity.model';
import { Store } from '@ngrx/store';

@Injectable()
export class OrderDetailsEffects {

  protected logger = inject(LoggerService);

  constructor(
    private actions: Actions,
    private apiService: ApiService,
    private globalService: GlobalService,
    private orderDetailsEffectsService: OrderDetailsEffectsService,
    private store: Store,
  ) { }

  DeleteSingleEntryDetails$ = createEffect(() =>
    this.actions.pipe(
      ofType(OrderDetailsActions.entryOrderdetails),  // Check the action being dispatched
      switchMap((action) => this.apiService.deleteorderdetail(action.entrydetails.orderId, action.entrydetails.entryNumberValue, action.entrydetails.comment)),
      map(() => {
        return OrderDetailsActions.entryOrderdetailsSuccess({ success: true });
      }),
      catchError((error) => {
        return of(OrderDetailsActions.entryOrderdetailsFail({ payload: tryNormalizeHttpError(error, this.logger) }));
      })
    )
  );

  DeleteWholeOrderDeatils$ = createEffect(() =>
    this.actions.pipe(
      ofType(OrderDetailsActions.deleteWholeOrderdetails),
      switchMap((action) => this.apiService.deleteWholeOrder(action.entrydetails.orderId, action.entrydetails.comment)),
      map(() => {
        this.globalService.loadingSubject.next(false);
        return OrderDetailsActions.deleteWholeOrderdetailsSuccess({ wholeOrderstatus: true });
      }),
      catchError((error) => {
        return of(OrderDetailsActions.deleteWholeOrderdetailsFail({ payload: tryNormalizeHttpError(error, this.logger) }));
      })
    )
  );

  RecreateOrderDetails$ = createEffect(() =>
    this.actions.pipe(
      ofType(OrderDetailsActions.recreateOrderDetails),
      switchMap((action) =>
        this.apiService.recreate(action.orderId)
          .pipe(
            tap(() => {
              // Prevent the early cart-page GET API calls even before the browserStorage is updated
              this.store.dispatch(SharedActions.clearCartsByLegalEntity())
            }),
            map((data: CustomCart) => data),
            concatMap((data: CustomCart) => {
              const payload: CartsByLegalEntity = this.orderDetailsEffectsService.recreateCartSideEffects(data);
              return [
                SharedActions.loadCartsByLegalEntitySuccess({ payload }),
                OrderDetailsActions.recreateOrderDetailsSuccess({ response: data }),
              ];
            }),
            catchError((error) => of(
              OrderDetailsActions.recreateOrderDetailsFail({
                payload: tryNormalizeHttpError(error, this.logger)
              }))
            )
          )
      ),
    )
  );
}
